'use strict';
/**
 * @file
 * Author: Synapse-studio.
 */

var $wrapper = $('.comments-wrapper');
var $list = $('.comments-list');
$(document).ready(function() {
  loadMore();
  commentLike();
});

function loadMore() {
  var $button = $wrapper.find('.comments-more-button');
  $button.on('click', function() {
    $wrapper.addClass('comments-wrapper--is-loading');
    var entityId = drupalSettings.entityId;
    var page = $(this).attr('data-page');
    var url = '/comments/load/' + page;
    $.ajax({
      type: 'POST',
      url: url,
      data: {
        id: entityId
      },
      success: function(output) {
        $wrapper.removeClass('comments-wrapper--is-loading');
        if (output.result) {
          $list.append(output.data);
          $button.attr('data-page', ++page);
          commentLike();
          $list.find('.colorbox').colorbox('destroy');
        } else {
          $button.addClass('comments-more-button--disabled');
          $button.find('.comments-more-button-text').html('Комментариев больше нет');
        }
      }
    });
  });
}

function commentLike() {
  var $comments = $('.comment');
  $comments.each(function() {
    var $comment = $(this);
    var $button = $comment.find('.comment-likes-button');
    $button.off().on('click', function() {
      if ($button.hasClass('comment-likes-button--disabled')) {
        iziToast.error({
          title: 'Вы уже голосовали за данный комментарий'
        });
        return;
      }
      $button.addClass('comment-likes-button--disabled');
      var commentId = $button.attr('data-comment-id');
      var url = '/comment/like/' + commentId;
      $.ajax({
        type: 'GET',
        url: url,
        success: function(output) {
          iziToast[output.type]({
            title: output.message,
          });
          if (output.type === 'success') {
            var $likesElement = $comment.find('.comment-likes-count');
            $likesElement.html(output.likes);
          }
        }
      });
    });
  });
}
if (typeof(Drupal) === 'object') {
  Drupal.behaviors.syncomments = {
    attach: function(context) {
      // Drupal behaviors!
    }
  };
}
